import cookie from "js-cookie";

import { isDesktopApp } from "~/lib/utils";

// This file is duplicated in /apps/outlook/lib/AccountStoreMin
// Please duplicate any changes here to there
const ACCOUNT_STORE_KEY = "fellow_accounts";

// This file is duplicated in /apps/outlook/lib/AccountStoreMin
// Please duplicate any changes here to there
type Account = {
	id: string;
	name: string;
	subdomain: string;
	logo: string;
	uri: string;
};

// This file is duplicated in /apps/outlook/lib/AccountStoreMin
// Please duplicate any changes here to there
type StoredAccount = Account & { timestamp: number };

// This file is duplicated in /apps/outlook/lib/AccountStoreMin
// Please duplicate any changes here to there
cookie.defaults.secure = true;

function setCookie(stored: { [key: string]: StoredAccount }) {
	cookie.set(ACCOUNT_STORE_KEY, JSON.stringify(stored), {
		expires: 365,
		domain: window.ROOT_DOMAIN,
		path: "/",
		secure: true,
		httponly: false,
		sameSite: "none",
	});
}

export default class AccountStore {
	static get(): { [key: string]: StoredAccount } {
		// This file is duplicated in /apps/outlook/lib/AccountStoreMin
		// Please duplicate any changes here to there
		const stored = cookie.get(ACCOUNT_STORE_KEY);
		if (!stored) return {};
		return JSON.parse(stored);
	}

	/**
	 * Returns a list of all accounts in the cookie
	 */
	static getAll(): Account[] {
		return Object.values(AccountStore.get()).sort((a, b) => b.timestamp - a.timestamp);
	}

	/**
	 * Returns a list of all accounts in the cookie, excluding the current one
	 */
	static getOthers() {
		const stored = Object.values(AccountStore.get()).sort((a, b) => b.timestamp - a.timestamp);
		if (!stored) return [];

		const { account } = window.INITIAL_STATE;
		if (!account) return [];

		return stored.filter((acc: StoredAccount) => acc.id != account.relay_id);
	}

	/**
	 * Returns the last accessed account
	 */
	static getLastAccessed(): Account | null {
		const stored = AccountStore.getAll();
		if (!stored.length) return null;
		return stored[0];
	}

	/**
	 * Stores an account in the cookie
	 * @param account
	 */
	static put(account: Account) {
		// This file is duplicated in /apps/outlook/lib/AccountStoreMin
		// Please duplicate any changes here to there
		const stored = AccountStore.get();

		stored[account.id] = {
			id: account.id,
			name: account.name,
			subdomain: account.subdomain,
			logo: account.logo,
			uri: account.uri,
			timestamp: Date.now(),
		};

		setCookie(stored);
	}
}

if (isDesktopApp) {
	window.ACCOUNT_STORE = AccountStore;
}
